/* eslint-disable eslint-comments/disable-enable-pair, security/detect-object-injection */
import dictionary from 'src/consts/filtersShortNames.json';


const mapSearchParamsToQueryObject = searchParams => Object.keys(searchParams).reduce((queryObject, parameterName) => {
  if (!dictionary[parameterName]) return queryObject;

  const value = searchParams[parameterName];
  const queryName = dictionary[parameterName];
  const newObjectValue = queryObject[queryName] ? [...queryObject[queryName], ...value] : value;

  return {
    ...queryObject,
    [queryName]: newObjectValue
  };
}, {});
export default mapSearchParamsToQueryObject;
